<div *ngIf="!isR104 && islegend" class="single-stats-widget">
	<div class="single-stats" *ngFor="let singleStat of overviewSingleStatData; let i = index">
		<div
			class="o-grid__cell data-cell"
			*ngIf="enabled"
			[ngClass]="{ noData: !hasData, noYoutubeData: !youtubeViewsPermission }"
		>
			<div
				class="{{ singleStat.statColor }} data-section"
				*ngIf="singleStat.hasData"
				appTooltip
				title="Tooltip"
				[title]="singleStat.tooltipInfo"
				data-size="big"
				[options]="tooltipOptions"
				[ngClass]="{ 'no-youtube-views': !youtubeViewsPermission }"
			>
				<div class="data-title">{{ singleStat.statName | uppercase }}</div>
				<div class="data-count">{{ singleStat.stat | formatNumber }}</div>
				<div *ngIf="singleStat.statPercentage" class="data-percentage">{{ singleStat.statPercentage }}</div>
			</div>
			<div
				class="{{ singleStat.statColor }} data-section no-data-container"
				*ngIf="!singleStat.hasData"
				appTooltip
				title="Tooltip"
				[title]="singleStat.tooltipInfo"
				data-size="big"
				[options]="tooltipOptions"
				[ngClass]="{ 'no-youtube-views': !youtubeViewsPermission }"
			>
				<div class="data-title">{{ singleStat.statName | uppercase }}</div>
				<div class="no-data-text no-data-text-quick-stat">No Data Available</div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="isR104 && islegend && hasData" class="single-stats-widget">
	<div class="single-stats" *ngFor="let singleStat of overviewSingleStatData; let i = index">
		<div
			class="o-grid__cell data-cell"
			*ngIf="enabled"
			[ngClass]="{ noData: !hasData, noYoutubeData: !youtubeViewsPermission }"
		>
			<div
				class="{{ singleStat.statColor }} data-section"
				*ngIf="singleStat.hasData"
				appTooltip
				title="Tooltip"
				[title]="singleStat.tooltipInfo"
				data-size="big"
				[options]="tooltipOptions"
				[ngClass]="{ 'no-youtube-views': !youtubeViewsPermission }"
			>
				<div class="data-title">{{ singleStat.statName | uppercase }}</div>
				<div class="data-count">{{ singleStat.stat | formatNumber }}</div>
				<div *ngIf="singleStat.statPercentage" class="data-percentage">{{ singleStat.statPercentage }}</div>
			</div>
			<div
				class="{{ singleStat.statColor }} data-section no-data-container"
				*ngIf="!singleStat.hasData"
				appTooltip
				title="Tooltip"
				[title]="singleStat.tooltipInfo"
				data-size="big"
				[options]="tooltipOptions"
				[ngClass]="{ 'no-youtube-views': !youtubeViewsPermission }"
			>
				<div class="data-title">{{ singleStat.statName | uppercase }}</div>
				<div class="no-data-text no-data-text-quick-stat">No Data Available</div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="isR104 && islegend && !hasData" class="r104 single-stats-widget no-data-container">
	<div class="no-data-text no-data-text-quick-stat">No Data Available</div>
</div>
<div *ngIf="!islegend">
	<div
		class="o-grid__cell data-cell"
		*ngIf="enabled"
		[ngClass]="{ noData: !hasData, noYoutubeData: !youtubeViewsPermission }"
	>
		<div
			class="{{ sectionclass }} data-section"
			*ngIf="hasData"
			appTooltip
			title="Tooltip"
			[title]="tooltipinfo"
			data-size="big"
			[options]="tooltipOptions"
			[ngClass]="{ 'no-youtube-views': !youtubeViewsPermission }"
		>
			<div class="data-title">{{ sectiontitle | uppercase }}</div>
			<div class="data-count">{{ singleStatData.stat | formatNumber }}</div>
			<div *ngIf="singleStatData.statPercentage" class="data-percentage">{{ singleStatData.statPercentage }}</div>
		</div>
		<div
			class="{{ sectionclass }} data-section no-data-container"
			*ngIf="!hasData"
			appTooltip
			title="Tooltip"
			[title]="tooltipinfo"
			data-size="big"
			[options]="tooltipOptions"
			[ngClass]="{ 'no-youtube-views': !youtubeViewsPermission }"
		>
			<div class="data-title">{{ sectiontitle | uppercase }}</div>
			<div class="no-data-text no-data-text-quick-stat">No Data Available</div>
		</div>
	</div>
</div>
